import React from "react";
import classes from "./InfoModal.module.css";

const InfoModal = ({ closeModal }) => {
  return (
    <div className={classes.modal_container}>
      <div className={classes.modal_subcontainer}>
        <h2 className={classes.text_main}>How To Play</h2>
        <p className={classes.text_secondary}>Guess the Word in 6 tries.</p>
        <ul>
          <li className={classes.text_secondary_2}>
            Each guess must be a valid 5-letter word.
          </li>
          <li className={classes.text_secondary_2}>
            The color of the tiles will change which indicates , the colored
            letter is in the word that you need to guess.
          </li>
        </ul>
        <h3 className={classes.text_main_2}>Examples</h3>
        <ul>
          <li style={{ listStyle: "none" }}>
            <div>
              <div className={classes.word_container}>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  T
                </div>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  R
                </div>
                <div className={classes.letter}>I</div>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  E
                </div>
                <div className={classes.letter}>D</div>
              </div>
              <strong style={{ color: "black" }}>T R E </strong>
              <span className={classes.span_word}>
                is in the word that you need to guess.
              </span>
            </div>
          </li>
          <li style={{ listStyle: "none" }}>
            <div className={classes.word_container}>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                R
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                E
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                A
              </div>
              <div className={classes.letter}>D</div>
              <div className={classes.letter}>Y</div>
            </div>
            <strong style={{ color: "black" }}>R E A </strong>{" "}
            <span className={classes.span_word}>
              is in the word that you need to guess.
            </span>
          </li>
          <li style={{ listStyle: "none" }}>
            <div className={classes.word_container}>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                T
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                R
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                E
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                A
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                T
              </div>
            </div>
            <strong style={{ color: "black" }}>Congratulations! </strong>
            <span className={classes.span_word}>You guessed right</span>
          </li>
        </ul>
        <div className={classes.btn_container}>
          <button className={classes.close_button} onClick={closeModal}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
